import { Typography, Tooltip, Box } from "@material-ui/core";
import UserProfileWidget from "Components/widgets/UserProfileWidget";
import { get } from "lodash";
import React from "react";
import { useStyles } from "./styles";

const ProfileView = ({ parentComment }) => {
  const classes = useStyles();
  return (
    <div className={classes.userName}>
      <Box display="flex">
        <Box textAlign="center" className={`${classes.commentuserInfo} mr5`}>
          <UserProfileWidget
            firstName={get(parentComment, "createdBy.firstName", "")}
            lastName={get(parentComment, "createdBy.lastName", "")}
            url={get(parentComment, "createdBy.profileImage.fileName", "")}
          />
        </Box>
        <Box width="130px">
          <Tooltip
            title={`${get(parentComment, "createdBy.firstName", "")} ${get(
              parentComment,
              "createdBy.lastName",
              ""
            )}`}
          >
            <Typography
              variant="body2"
              className="font-12 font-semibold"
              pt={1}
              noWrap="true"
            >
              {get(parentComment, "createdBy.firstName", "")}{" "}
              {get(parentComment, "createdBy.lastName", "")}
            </Typography>
          </Tooltip>
          <Typography variant="body2" className="font-11 f-light-gray">
            {get(parentComment, "createdBy.department", "")}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default ProfileView;
